import React, { Component } from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Link, withRouter } from 'react-router-dom'
import { Button, AppBar, Toolbar, Grid, IconButton } from '@material-ui/core'
import { setLanguage } from 'redux-i18n'
import './SandHeader.scss'
import Languageselector from '../../Languageselector'

class SandHeader extends Component {
	handleChange = e => {
		const selectedLang = e.target.value
		this.props.setLanguage(selectedLang)
	}

	render() {
		const { user, i18nState } = this.props

		return (
			<Grid>
				<AppBar className="SAppBar" color="default" position="static">
					<Toolbar eventkey={0} isopen={user} className="navbarItem">
						<IconButton href="/" className="brand" color="inherit" aria-label="Logo" />
						<div className="nav__icons">
							<Grid item>
								<Languageselector />
							</Grid>

							{(!user || !user.isVerified) && (
								<Link to="/login-talent">
									<Button className="register_but" eventkey={6}>
										{this.context.t('register-login')}
									</Button>
								</Link>
							)}
						</div>
					</Toolbar>
				</AppBar>
			</Grid>
		)
	}
}

SandHeader.contextTypes = {
	t: PropTypes.func
}

SandHeader.propTypes = {
	isLoggedIn: PropTypes.bool.isRequired,
	user: PropTypes.object,
	history: PropTypes.object.isRequired,
	i18nState: PropTypes.object.isRequired,
	setLanguage: PropTypes.func.isRequired
}

const mapStateToProps = state => ({
	isLoggedIn: state.authReducer.isLoggedIn,
	user: state.authReducer.user,
	i18nState: state.i18nState
})

const mapDispatchToProps = {
	setLanguage
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(SandHeader))
